// extracted by mini-css-extract-plugin
export default {"alertWrapper":"Alert_alertWrapper__hcZKW","isAlertActive":"Alert_isAlertActive__EBGY9"};